// EmailJS browser configuration is public. Never put private keys or email passwords here.
export const emailJsConfig = {
  serviceId: 'service_lph9p1o',
  templateId: 'template_ipc9wrm',
  publicKey: 'QrPnBf3pV2rQlyRVC',
}
